// extracted by mini-css-extract-plugin
export default {"cell":"NewUserListItem_cell__5Sy1t","hidden":"NewUserListItem_hidden__U3qDM","error":"NewUserListItem_error__2tAyb","breathing":"NewUserListItem_breathing__U8-sK"};